var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tooltipText)?_c('div',[_c('label',{class:[
        _vm.base.label,
        _vm.type[_vm.typeScaleClass(_vm.textSize)],
        !_vm.helpText && _vm.space.marginBottomNarrow
      ],attrs:{"for":_vm.id}},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]),_c('BaseTooltip',{attrs:{"body":_vm.tooltipText}})],1):_c('label',{class:[
      _vm.base.label,
      _vm.type[_vm.typeScaleClass(_vm.textSize)],
      !_vm.helpText && _vm.space.marginBottomNarrow
    ],attrs:{"for":_vm.id}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),(_vm.helpText)?_c('BaseBodyText',{class:_vm.base.help,attrs:{"content":_vm.helpText,"size":_vm.helpTextSize,"font":"display"}}):_vm._e(),_vm._t("default",[_vm._v("Add a form component here")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }